import { InlineLoading, InlineNotification } from '@carbon/react';
import { useAtomValue } from 'jotai';
import { createResourceAtom } from 'lib/atoms';
import { startCase } from 'lodash-es';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { TypeCurveScenarioResponse } from '../type-curve-scenario-form/types';
import { TypeCurveScenarioForm } from '../type-curve-scenario-form/type-curve-scenario-form';

export const EditTypeCurveScenarioPage = () => {
  const { pathname } = useLocation();

  const resourceAtom = useMemo(
    () => createResourceAtom<TypeCurveScenarioResponse>(pathname),
    [pathname]
  );
  const resource = useAtomValue(resourceAtom);

  if (resource.loading) return <InlineLoading />;

  if (resource.data && 'error' in resource.data)
    return (
      <InlineNotification
        kind="error"
        title={resource.data.error}
        lowContrast
      />
    );

  if (!resource.data)
    return (
      <InlineNotification
        kind="error"
        title="Something went wrong"
        lowContrast
      />
    );

  const scenarioName = startCase(resource.data.name);
  const isReadOnly =
    resource.data.auth && !resource.data.auth.includes('update');

  return (
    <TypeCurveScenarioForm
      initialValues={{
        name: resource.data.name,
        dcaScenarioId: resource.data.dcaScenario
          ? String(resource.data.dcaScenario.id)
          : null,
        dcaScenarioName: resource.data.dcaScenario?.name || null,
        status: resource.data.status,
        notes: resource.data.notes || '',
        createdBy: resource.data.createdBy || '',
      }}
      scenarioName={scenarioName}
      pageHref={resource.data.href}
      commentsUrl={resource.data.resources.comments.href}
      eventsUrl={resource.data.resources.events.href}
      areaConfigsUrl={resource.data.resources.areaConfigs.href}
      readOnly={isReadOnly}
    />
  );
};
